import type { Action, ThunkAction } from "@reduxjs/toolkit"
import type { ThunkDispatch } from '@reduxjs/toolkit';
import { isPlainObject } from '@reduxjs/toolkit';

import { combineSlices, configureStore } from "@reduxjs/toolkit"
import { productsSlice } from "../redux/products/products"
import { progressSlice } from "../redux/progress-bar/progressBar"
import { userSelectionSlice } from "../redux/user-selection/userSelection"
import { bookingSlice } from "../redux/booking/booking"
import { paymentSlice } from "../redux/payment/payment"
import { pickupSlice } from "../redux/pickup/pickup"
import { availabilitySlice } from "../redux/availability/availability"
import { countiesSlice } from "../redux/pupil/counties"

import { ProductsService } from '../services/products/ProductsService';
import { PickupService } from '../services/pickup/PickupService';
import { CountyService } from '../services/pupil/CountyService';
import { AvailabilityService } from '../services/availability/AvailabilityService';
import { BookingService } from '../services/booking/BookingService';
import { APIService } from '../services/api/APIService';

export interface ThunkServices {
    productService: ProductsService;
    pickupService: PickupService;
    countyService: CountyService;
    availabilityService: AvailabilityService;
    bookingService: BookingService;
}

export const apiService = new APIService();

export const serviceContainer: ThunkServices = {
    productService: new ProductsService(apiService),
    pickupService: new PickupService(apiService),
    countyService: new CountyService(apiService),
    availabilityService: new AvailabilityService(apiService),
    bookingService: new BookingService(apiService)
};


export const rootReducer = combineSlices(
  progressSlice,
  productsSlice,
  pickupSlice,
  countiesSlice,
  progressSlice,
  userSelectionSlice,
  bookingSlice,
  paymentSlice,
  pickupSlice,
  availabilitySlice
)
// Infer the `RootState` type from the root reducer
export type RootState = ReturnType<typeof rootReducer>

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: serviceContainer, // Pass your services here
      },
      serializableCheck: false,
    }),
});

export type AppThunkDispatch = ThunkDispatch<RootState, unknown, Action<string>>;

// Infer the type of `store`
export type AppStore = typeof store
// Infer the `AppDispatch` type from the store itself
export type AppDispatch = AppStore["dispatch"]
export type AppThunk<ThunkReturnType = void> = ThunkAction<
  ThunkReturnType,
  RootState,
  unknown,
  Action
>
